import React from 'react';

interface Props {
  currentPage?: number;
  pageSize?: number;
  totalCount?: number;
}

export default function PageHeaderCount({ currentPage, pageSize, totalCount }: Props) {
  if (!currentPage || !pageSize || !totalCount) {
    return null;
  }

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalCount);
  return (
    <span className="text-muted d-none d-md-block">
      Displaying <strong>{start}-{end}</strong> of <strong>{totalCount}</strong>
    </span>
  );
}
